
<template>
    <div @wheel="testingScrool">
        <!-- <div class="glass" v-if="!move" @mousedown="move = true;" @mouseup="move = false;"></div> -->
        <div id="container" ></div>
    </div>
</template>

<script>
import * as THREE from 'three';
import { GUI } from 'three/addons/libs/lil-gui.module.min.js';

import { PLYLoader } from 'three/addons/loaders/PLYLoader.js';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';

export default {
    data() {
        return {
            move: false,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        testingScrool(ev) {
            ev.stopPropagation();
        ev.preventDefault();
        ev.returnValue = false;
        },
        animate: function () {
            requestAnimationFrame(this.animate);
            render();
    
        },
        render() {
            const time = performance.now() / 3000;

            this.spotLight.position.x = Math.cos(time) * 25;
            this.spotLight.position.z = Math.sin(time) * 25;

            this.lightHelper.update();

            this.renderer.render(this.scene, this.camera);
        },
        onWindowResize() {

            this.camera.aspect = window.innerWidth / window.innerHeight;
            this.camera.updateProjectionMatrix();

            this.renderer.setSize(window.innerWidth, window.innerHeight);

        },
        test(geometry) {

            geometry.scale(0.014, 0.014, 0.014);
            geometry.computeVertexNormals();

            const material = new THREE.MeshLambertMaterial();

            const mesh = new THREE.Mesh(geometry, material);
            mesh.rotation.y = - Math.PI / 2;
            mesh.position.y = 18;
            mesh.castShadow = true;
            mesh.receiveShadow = true;
            console.log(this.scene);
            this.scene.add(mesh);

        },
        init() {
            let container = document.getElementById('container');

            this.renderer = new THREE.WebGLRenderer({ antialias: true });
            this.renderer.setPixelRatio(window.devicePixelRatio);
            this.renderer.setSize(window.innerWidth, window.innerHeight);
            container.appendChild(this.renderer.domElement);

            this.renderer.shadowMap.enabled = true;
            this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;

            this.renderer.outputEncoding = THREE.sRGBEncoding;

            this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
            this.renderer.toneMappingExposure = 1;
            this.renderer.setAnimationLoop(this.render);

            this.scene = new THREE.Scene();

            this.camera = new THREE.PerspectiveCamera(40, window.innerWidth / window.innerHeight, 1, 1000);
            this.camera.position.set(70, 50, 10);

            const controls = new OrbitControls(this.camera, this.renderer.domElement);
            controls.minDistance = 50;
            controls.maxDistance = 50;
            controls.maxPolarAngle = Math.PI / 2;
            controls.target.set(0, 18, 0);
            controls.update();

            const ambient = new THREE.HemisphereLight(0xffffff, 0x101010, 0.05);
            this.scene.add(ambient);

            const loader = new THREE.TextureLoader()//.setPath( 'textures/' );
            const filenames = ['disturb.jpg', 'colors.png', 'uv_grid_opengl.jpg'];

            const textures = { none: null };

            for (let i = 0; i < filenames.length; i++) {

                const filename = filenames[i];

                const texture = loader.load('disturb.jpg');
                texture.minFilter = THREE.LinearFilter;
                texture.magFilter = THREE.LinearFilter;
                texture.encoding = THREE.sRGBEncoding;

                textures[filename] = texture;

            }

            this.spotLight = new THREE.SpotLight(0xffffff, 5);
            this.spotLight.position.set(125, 50, 25);
            this.spotLight.angle = Math.PI / 6;
            this.spotLight.penumbra = 1;
            this.spotLight.decay = 0;
            this.spotLight.distance = 100;
            this.spotLight.map = textures['disturb.jpg'];
            this.spotLight.intensity = 10;

            this.spotLight.castShadow = false;
            this.spotLight.shadow.mapSize.width = 512;
            this.spotLight.shadow.mapSize.height = 512;
            this.spotLight.shadow.camera.near = 10;
            this.spotLight.shadow.camera.far = 10;
            this.spotLight.shadow.focus = 1;
            this.scene.add(this.spotLight);

            this.lightHelper = new THREE.SpotLightHelper(this.spotLight);
            this.scene.add(this.lightHelper);

            //

            const geometry = new THREE.PlaneGeometry(1000, 1000);
            const material = new THREE.MeshLambertMaterial({ color: 0x101010 });

            const mesh = new THREE.Mesh(geometry, material);
            mesh.position.set(0, 8, 0);
            mesh.rotation.x = - Math.PI / 2;
            mesh.receiveShadow = true;
            this.scene.add(mesh);

            //

            new PLYLoader().load('Lucy100k.ply', this.test);

            window.addEventListener('resize', this.onWindowResize);

            this.renderer.render(this.scene, this.camera);

        },
        onPointerMove(event) {

            pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
            pointer.y = - (event.clientY / window.innerHeight) * 2 + 1;

        },
    }
}
</script>
<style lang="scss">
#container {
    height: 100vh;
    max-width: 100vw;
    > canvas {
        max-width: 100vw;
    }
}
.glass {
 position: absolute;
 top:0;
 bottom:0;
 left:0;
 right:0;
 background: red;
}
</style>